import {  Layout, Row, Col} from 'antd';
import React, { useState} from "react";
import {NavLink} from "react-router-dom";
import '../evento.css';
import { withTranslation  } from 'react-i18next';


const WordCounter = ({ value, onChange,t }) => {
  const [content, setContent] = useState(value);
  const [wordCount, setWordCount] = useState(0);
console.log("VALUE",value)
 

  const setFormattedContent = (text)=>{
    var words = text.split(' ').filter(Boolean);
    if (words.length > 250) {
      setContent(words.slice(0, 250).join(' '))
      setWordCount(250)
    } else {
      setContent(text)
      setWordCount(words.length)
    }
    onChange(text)
  }

  return (
    <div>
      <textarea
      className = 'orange-border'
      
      placeholder={t('No exceda 250 palabras')} 
      style={{width:'80%'}}
                    onChange={event =>wordCount==250 && content == event.target.value ? setContent(content): setFormattedContent(event.target.value)}
          value={content}
          init={""}
        />
        <p>
          {wordCount}/{250}
        </p>
        </div>
  );
};

export default withTranslation() (WordCounter);


